<template>
  <div>
    <mdb-row style="margin-bottom: -4rem;">
      <mdb-col md="3" class="card-div">
        <div class="title-style">
          {{loginUserType=='SUPER_ADMIN'?'Administradores':'Usuarios'}}
          <br />
          <div style="width: 120%;font-size: 16px; font-weight: lighter;; display: -webkit-box;">
            {{loginUserType=='SUPER_ADMIN'?'Administradores registrados':'Total Usuarios'}}: &nbsp;
            <span style="font-size:18px; font-weight:600">{{ totalOfElements }}</span>
          </div>
        </div>
      </mdb-col>
      <mdb-col md="5" class="card-div searchBar">
        <input
          class="input-style"
          type="text"
          name="buscador"
          id="search"
          v-model="search"
          style="width: 35vw;"
          placeholder="Buscar usuarios por Correo electrónico o Tipo de usuario."
        />
        <mdb-card v-if="showFilterUser" class="filterStyle">
          <mdb-card-body>
            <mdb-row>
              <label
                for="userType"
                class="labelPop"
                style="font-size: 10px !important;"
              >Filtrar por tipo de usuario:</label>
            </mdb-row>
            <mdb-row>
              <div id="userType" style="display: flex; margin-bottom: 1rem;">
                <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" lg="5">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="ASocios" v-model="userTypeFilter" value="PARTNER_SERVICE" />
                      <label for="ASocios" style=" font-size: 15px; font-weight: 600; color: #000;">
                        <span :class="userTypeFilter == 'PARTNER_SERVICE' ? 'form__label-active' : ''"></span>Atención a socios
                      </label>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" lg="3">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="Comite" v-model="userTypeFilter" value="COMMITTEE" />
                      <label for="Comite" style="font-size: 15px; font-weight: 600; color: #000;">
                        <span :class="userTypeFilter == 'COMMITTEE' ? 'form__label-active' : ''"></span>Comité
                      </label>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" lg="3">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="ventas" v-model="userTypeFilter" value="SALES" />
                      <label for="ventas" style=" font-size: 15px; font-weight: 600; color: #000;;">
                        <span :class="userTypeFilter == 'SALES' ? 'form__label-active' : ''"></span>Ventas
                      </label>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col v-if="loginUserType == 'SUPER_ADMIN'" lg="5">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="Administrador" v-model="userTypeFilter" value="CLUB_ADMIN" />
                      <label for="Administrador" style=" font-size: 15px; font-weight: 600; color: #000;">
                        <span :class="userTypeFilter == 'CLUB_ADMIN' ? 'form__label-active' : ''"></span>Administrador de club
                      </label>
                    </div>
                  </div>
                </mdb-col>
              </div>
            </mdb-row>
            <mdb-row>
              <div style="display: flex; margin-bottom: 1rem;">
                <mdb-col lg="3">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="todos" v-model="userTypeFilter" value="" />
                      <label for="todos" style=" font-size: 15px; font-weight: 600; color: #000;;">
                        <span :class="userTypeFilter == '' ? 'form__label-active' : ''"></span>Todos
                      </label>
                    </div>
                  </div>
                </mdb-col>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
      <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" md="2" class="card-div">
        <div>
          <button class="btn buttonFilter" type="button" @click="showFilterUser = !showFilterUser">
            <img src="../../../../public/img/icons/InoFiltrar.svg" alt="filtrar" />
          </button>
        </div>
      </mdb-col>
    </mdb-row>

    
    <mdb-row>
        <b-table :items="dataList" :fields="columns" class="text-center" :responsive="true" :no-provider-paging="true"
            :show-empty="true"
            emptyText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda."
            emptyFilteredText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda.">
            
            <template #cell(userType)="data">
              <div v-if="data.item.userType == 'CLUB_ADMIN'" class="text-center">Administrador</div>
              <div v-else-if="data.item.userType == 'PARTNER_SERVICE'" class="text-center">Atención a socios</div>
              <div v-else-if="data.item.userType == 'COMMITTEE'" class="text-center">Comité</div>
              <div v-else-if="data.item.userType == 'SALES'" class="text-center">Ventas</div>
              <div v-else class="text-center">Administrador sin asignar</div>
            </template>

            <template #cell(clubName)="data">
              <div v-if="loginUserType == 'SUPER_ADMIN'" class="text-center">{{data.item.clubName}}</div>
            </template>

            <template #cell(options)="data">
              <div>
                <button
                  type="button"
                  class="btn btn-edit"
                  @click="editUserOpenModal(data.item.id, data.item.email, data.item.userType)"
                >
                  <img :src="'/img/icons/InoEditarr.svg'" alt="icon editar" />
                </button>
                <button type="button" class="btn btn-delete" @click="eliminarUserOpenModal(data.item.id)">
                  <img :src="'/img/icons/InoBorrar.svg'" alt="icon borrar" />
                </button>
              </div>
            </template>
        </b-table>
    </mdb-row>

    <Paginator stylePaginator="full" :currentPage="page" :totalRows="totalOfElements" :perPage="perPage"
        @changePage="changePage" @changePerPage="changePerPage" />

    <!-- <mdb-row>
      <table class="t1-table text-center">
        <tr>
          <th>Tipo de usuario</th>
          <th>Correo electrónico</th>
          <th v-if="loginUserType == 'SUPER_ADMIN'">Club</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in dataList" v-bind:key="index">
          <td v-if="item.userType == 'CLUB_ADMIN'" class="text-center">Administrador</td>
          <td v-else-if="item.userType == 'PARTNER_SERVICE'" class="text-center">Atención a socios</td>
          <td v-else-if="item.userType == 'COMMITTEE'" class="text-center">Comité</td>
          <td v-else-if="item.userType == 'SALES'" class="text-center">Ventas</td>
          <td v-else class="text-center">Administrador sin asignar</td>
          <td class="text-center">{{item.email}}</td>
          <td v-if="loginUserType == 'SUPER_ADMIN'" class="text-center">{{item.clubName}}</td>
          <td class="text-center">
            <div>
              <button
                type="button"
                class="btn btn-edit"
                @click="editUserOpenModal(item.id, item.email, item.userType)"
              >
                <img :src="'/img/icons/InoEditarr.svg'" alt="icon editar" />
              </button>
              <button type="button" class="btn btn-delete" @click="eliminarUserOpenModal(item.id)">
                <img :src="'/img/icons/InoBorrar.svg'" alt="icon borrar" />
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="!dataList || dataList.length === 0">
                <td></td>
                <td>No se ha(n) encontrado resultado(s) de usuarios que coincida(n) con tu búsqueda.</td>
                <td></td>
                <td></td>
            
            </tr>
      </table>
    </mdb-row> -->
    <!-- <mdb-row>
      <mdb-col>
        <Btn
          type="primary-block2"
          @onClick="closeModal"
          icon="plus"
          :text="titlePop"
          class="btn-add"
        />
      </mdb-col>
      <mdb-col>
        <div class="selectdiv">
          <div>
            <nav style="position: absolute; right: 80%;">
               <ul class="t1-pagination">
                <li v-if="page != 1">
                  <a @click="page--">
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(90deg)" />
                  </a>
                </li>
                 <li
                            v-for="pageNumber in numberOfPages"
                            :class="pageNumber === page ? 't1-pagination--active':''"
                            :key="pageNumber"
                    >
                        <a @click="page = pageNumber">{{pageNumber}}</a>
                    </li>

                <li v-if="page < pages.length" @click="page++">
                  <a>
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(270deg)" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div>
            <select name="pages" id="pages">
              <option value="1">Pag. 1</option>
              <option value="2">Pag. 2</option>
              <option value="3">Pag. 3</option>
            </select>
          </div>
        </div>
      </mdb-col>
    </mdb-row> -->
    <mdb-row></mdb-row>
    <Popup
      size="sm"
      :title="titlePop"
      :header="classPop"
      classTitle="popup__title-mod"
      ref="usuario"
    >
      <label for="datosTitular" class="modal-admin-title mt-3">{{subTitle}}.</label>
      <div id="datosTitular" style="height: auto;" class="mt-3">
        <mdb-col>
          <mdb-row v-if="loginUserType == 'CLUB_ADMIN'">
            <label
              for="userType"
              class="labelPop"
              style="font-size: 1.3rem !important;"
            >Selecciona el tipo de usuario:</label>
          </mdb-row>
          <mdb-row>
            <div id="userType" style="display: flex; margin-bottom: 1rem;">
              <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" md="6">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="ASocios" v-model="userType" value="PARTNER_SERVICE" />
                    <label for="ASocios" style="font-size: 14px; font-weight: 400;">
                      <span :class="userType == 'PARTNER_SERVICE' ? 'form__label-active' : ''"></span>Atención a socios
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="Comite" v-model="userType" value="COMMITTEE" />
                    <label for="Comite" style="font-size: 14px; font-weight: 400;">
                      <span :class="userType == 'COMMITTEE' ? 'form__label-active' : ''"></span>Comité
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col v-if="loginUserType == 'CLUB_ADMIN'" md=4>
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" id="ventas" v-model="userType" value="SALES" />
                      <label for="ventas" style="font-size: 14px; font-weight: 400;">
                        <span :class="userType == 'SALES' ? 'form__label-active' : ''"></span>Ventas
                      </label>
                    </div>
                  </div>
                </mdb-col>
            </div>
          </mdb-row>
          <mdb-row>
            <label
              for="email"
              class="labelPop"
              style="font-size: 1.3rem !important;"
            >Correo electrónico:</label>
            <input
              type="email"
              class="form__input"
              id="email"
              v-model="email"
              required
              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
              maxlength="150"
              style="height: 3.5rem;"
            />
            <span>{{charCount}}</span>
            <validation-error :validation="$v.email"></validation-error>
          </mdb-row>
          <mdb-row>
            <div class="mt-3" style="width: 100%;">
              <Btn
                @onClick="registerUser"
                :text="loginUserType == 'CLUB_ADMIN'?'Registrar usuario': 'Registrar administrador'"
                type="primary-admin"
                style="float:right; margin-left: 1rem;"
              ></Btn>
              <Btn
                @onClick="closeModal"
                :text="'Cancelar'"
                :type="'primary-admin-ghost'"
                style="float:right;"
              ></Btn>
            </div>
          </mdb-row>
        </mdb-col>
      </div>
    </Popup>
    <Popup size="sm" ref="deleteUser">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div
                style="font-family: Josefin Sans;
  font-size: 22px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #dc7134;
      margin-left: 10%;"
              >¿ELIMINAR USUARIO?</div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div
                style="font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f"
              >El registro del usuario será eliminado del sistema de forma permanente.</div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem;">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%;">
                <Btn
                  @onClick="eliminarUsuario"
                  :text="'Eliminar'"
                  :type="'primary-admin'"
                  style="float:right;"
                ></Btn>
                <Btn
                  @onClick="$refs.deleteUser.toggleModal()"
                  :text="'Cancelar'"
                  :type="'primary-admin-ghost'"
                  style="float:right; margin-right: 1rem;"
                ></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import Swal from "sweetalert2";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";
import Paginator from "../../core/Paginator.vue"
export default {
  name: "Users",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbCard,
    Btn,
    Popup,
    ValidationError,
    Paginator
  },
  data() {
    return {
      search: "",
      isLoading: false,
      totalOfElements: 0,
      page: 1,
      perPage: 10,
      numberOfPages: 0,
      dataList: [],
      dataListRespaldo: [],
      titlePop: "",
      classPop: "popup__header-admin",
      isEdit: false,
      email: "",
      idUser: "",
      userType: "",
      userTypeFilter: "",
      showFilterUser: false,
      subTitle: "",
      columns: [
                {
                    label: 'Tipo de usuario',
                    key: 'userType',
                    sort: false,
                    class: 'text-center',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff",
                        "border-top-left-radius": "5px",
                        "border-bottom-left-radius": "5px"
                    },
                    tdClass: "tableCol-start",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Correo electrónico',
                    key: 'email',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Club',
                    key: 'clubName',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: '', 
                    key: 'options', 
                    sort: false, 
                    class: 'text-center', 
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 2.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
            ],
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    ...mapActions([
      "getListOfUsersUnssigned",
      "getListOfUsers",
      "getListOfAdministrators",
      "postUser",
      "deleteUser"
    ]),
    cleanDataTable() {
      this.totalOfElements = 0;
      this.page = 1;
      this.perPage = 10;
      this.pages = [];
      this.numberOfPages = 0;
      this.search = "";
      this.dataList = [];
      this.dataListRespaldo = [];
    },
    async getUsers() {
      let params = {};
      params.clubCode = "CGTM";
      params.pageNumber =  this.page-1;
      params.pageSize = this.perPage;
      params.search = this.search;
      this.dataList = [];
      this.totalOfElements = 0;


      try {
        let response = await this.getListOfAdministrators(params);
        if (response.data.status === 200) { 
                    this.numberOfPages = response.data.totalPages;
                    this.totalOfElements = response.data.totalElements;
                    if(response.data.data!= null)
                      this.dataList = response.data.data;
    
          
          if(this.loginUserType == "CLUB_ADMIN"){
             this.dataList = response.data.data.filter(function(item) {
                return item.userType != "CLUB_ADMIN";
              });
          }
        } else{
                    this.dataList = [];
                    this.totalOfElements = 0;
        }
        if (this.loginUserType == "SUPER_ADMIN") {
          let response = await this.getListOfUsersUnssigned();
          if (response.data.data != null) {
            this.dataList = this.dataList.concat(response.data.data);
            this.totalOfElements =
            this.totalOfElements + response.data.data.length;
          }
        }

        // //console.log(this.dataList)
      } catch (error) {
        //console.log(error);
      }
    },
    async eliminarUsuario(){
      try {
          let response = await this.deleteUser(this.idUser);
           this.$refs.deleteUser.toggleModal();
             Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>USUARIO ELIMINADO CORRECTAMENTE</span>",
        html:
          "<div>" +
          "<span class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'></span>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "55rem",
        padding: "5rem",
        showConfirmButton: false,
        showCloseButton: true,
        onClose: () => {
            this.cleanDataTable();
            this.getUsers();
        }
      });
           
       
      } catch (error) {
        
      }
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / this.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    async registerUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        try {
          let body = {
            // clubCode: "CGTM",
            userType: this.userType,
            username: this.email
          };
          let response = await this.postUser(body);
          if (response.data.status == 200) {
            this.closeModal();
            this.registerDone();
            this.cleanDataTable();
            this.getUsers();

          }
        } catch (error) {
          //console.log(error.response.data.errorDetails);
          this.errorMessage(error.response.data.errorDetails);
        }
      }
    },
    closeModal() {
      this.isEdit = false;
      this.email = "";
      this.idUser = "";
      if (this.loginUserType == "SUPER_ADMIN") {
        this.userType = "CLUB_ADMIN";
        this.titlePop = "Agregar administrador ";
        this.subTitle =
          "Ingresa el correo del administrador que deseas registrar.";
      } else {
        this.userType = "PARTNER_SERVICE";
        this.titlePop = "Agregar usuario ";
        this.subTitle = "Ingresa el correo del usuario que deseas registrar.";
      }
      this.classPop = "popup__header-admin";
      this.$refs.usuario.toggleModal();
    },
    editUserOpenModal(id, email, userType) {
      this.isEdit = true;
      this.email = email;
      this.idUser = id;
      this.userType = userType;
      if (this.loginUserType == "SUPER_ADMIN") {
        this.userType = "CLUB_ADMIN";
        this.titlePop = "Editar administrador ";
        this.subTitle = "Edita el correo del administrador";
      } else {
        
        this.titlePop = "Editar usuario ";
        this.subTitle = "Edita el correo del usuario";
      }
      this.classPop = "popup__header-edit";
      this.$refs.usuario.toggleModal();
    },
    eliminarUserOpenModal(id){
      this.idUser = id;
       this.$refs.deleteUser.toggleModal();

    },
    registerDone() {
      Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>REGISTRO CORRECTO</span>",
        html:
          "<div>" +
          "<span class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'> REGISTRO DE USUARIO CORRECTO.</span>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "55rem",
        padding: "5rem",
        showConfirmButton: false,
        showCloseButton: true
      });
    },
    registerEditDone() {
      Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>CAMBIOS GUARDADOS CORRECTAMENTE</span>",
        html:
          "<div>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "50rem",
        padding: "4rem",
        showConfirmButton: false,
        showCloseButton: true
      });
    },
    errorMessage(text) {
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p>"+text+".</p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block"
        },
        onClose: () => {}
      }).then(result => {});
    },
    changePage(value) {
      this.page = value
    },
    changePerPage(value) {
      this.perPage = value
    },
  },
  mounted() {
    this.cleanDataTable();
    this.getUsers();
    if (this.loginUserType == "SUPER_ADMIN") {
      this.userType = "CLUB_ADMIN";
      this.titlePop = "Agregar administrador ";
      this.subTitle =
        "Ingresa el correo del administrador que deseeas registrar.";
    } else {
      this.userType = "PARTNER_SERVICE";
      this.titlePop = "Agregar usuario ";
      this.subTitle = "Ingresa el correo del usuario que deseeas registrar.";
    }
  },
  created() {},
  computed: {
    ...mapGetters({
      loginUserType: "getUserType"
    }),
    displayedPost() {
      return this.paginate(this.dataList);
    },
    charCount(){
      var char = this.email.length

        return (150 - char) + " / " + 150 + " Caracteres";

    }
  },
  watch:{
    search(){
       this.page = 1;
     this.getUsers();
    },
    page(){
      this.getUsers();
    },
    perPage() {
      this.getUsers();
    },
    userTypeFilter(val){
        
      if(val != ""){
        this.search = val;
       
      }
      else{
        this.search = ""
      }

    }

  },
};
</script>

<style scoped>
.modal-admin-title {
  font-family: Open Sans;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f;
}


.tableCol {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

.tableCol-start {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

.tableCol-end {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

@media (min-width: 1024px) and (max-width: 1449px) {

    .table td {
        padding: 0.25rem;
    }

    .tableCol-start {
        padding-left: 30px !important;
        padding-right: 10px !important;
    }


    table.table-status {
        width: 100%;
    }

    table.table-status th {
        color: #dc7134;
        font-size: 1.8em;
    }

    table.table-status td {
        font-size: 1.6em;
    }
}
</style>